<template>
  <div class="container py-0">
    <v-flex xs12 class="di-flex py-0 justify-end">
      <v-btn
        icon
        outline
        @click="print"
        color="primary"
        :loading="printMode"
        :title="$t('print_org_chart')"
      >
        <v-icon>print</v-icon>
      </v-btn>
    </v-flex>
    <v-container class="py-0" justify-center align-center ref="chart">
      <div class="flexRow align-center mb-4">
        <img :src="branch_logo" alt="SO" class="branch_logo" />
        <div class="flex-column" style="flex: 1">
          <div
            class="xs12"
            style="
              font-weight: 700;
              margin-top: 20px;
              font-size: 23px !important;
            "
          >
            {{ branch_fa_name }}
          </div>
          <div class="xs12 font-weight-bold title py-1">
            {{ LONG_APP_NAME }} <span class="body-2"></span>
          </div>
          <div class="subheading xs12 my-2 font-weight-bold">
            {{ $t("organization_chart") }} ( {{ branchName }} )
          </div>
        </div>
        <div class="branch_logo"></div>
      </div> 
      <template v-for="(group, key) in onboards">
        <v-layout
          row
          wrap
          :key="key + '<=3'"
          v-if="key <= 3"
          align-center
          :justify-center="key != 3"
          :justify-space-around="key == 3"
          class="animation avoid-page-break text-xs-center align-start"
        >
          <template v-if="key < 3">
            <v-flex
              md2
              :xs2="printMode"
              :xs12="!printMode"
              v-for="staff in group"
              :key="'staff_' + staff.id"
              class="flex flex-column avoid-page-break pa-0 mt-3"
              :style="
                staff.position_rank > 1
                  ? 'border-top:#13aa52 solid 3px !important'
                  : ''
              "
            >
              <board-tile :staff="staff" />
            </v-flex>
          </template>
          <template v-if="key == 3">
            <v-flex
              md5
              :xs5="printMode"
              :xs12="!printMode"
              v-for="staff in group"
              :key="'staff_' + staff.id"
              style="border-top: #13aa52 solid 3px !important"
              class="flex flex-column avoid-page-break pa-0 ma-3"
            >
              <board-tile :staff="staff" />
            </v-flex>
          </template>
          <template v-if="key > 5">
            <v-flex
              md4
              :xs4="printMode"
              :xs12="!printMode"
              v-for="staff in group"
              :key="'staff_' + staff.id"
              style="border-top: #13aa52 solid 3px !important"
              class="flex flex-column avoid-page-break pa-0 ma-3"
            >
              <board-tile :staff="staff" />
            </v-flex>
          </template>
        </v-layout>
      </template>

      <v-layout row wrap justify-center align-start>
        <v-flex
          md6
          :xs6="printMode"
          :xs12="!printMode"
          class="flex-row align-start justify-center text-xs-center"
        >
          <v-flex
            md3
            :xs3="printMode"
            :xs12="!printMode"
            v-for="staff in group4"
            :key="'staff_' + staff.id"
            class="flex flex-column avoid-page-break pa-0"
            style="border-top: #13aa52 solid 3px !important"
          >
            <board-tile :staff="staff" />
          </v-flex>
        </v-flex>
        <v-flex
          md6
          :xs6="printMode"
          :xs12="!printMode"
          class="flex-row align-start justify-center text-xs-center"
        >
          <v-flex
            md3
            :xs3="printMode"
            :xs12="!printMode"
            v-for="staff in group5"
            :key="'staff_' + staff.id"
            class="flex flex-column avoid-page-break pa-0"
            style="border-top: #13aa52 solid 3px !important"
          >
            <board-tile :staff="staff" />
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>

    <img :src="output" crossorigin="anonymous" />
  </div>
</template>
<script >
import { printBill } from "@/mixins";
import boardTile from "./boardTile.vue";

export default {
  components: { boardTile },
  mixins: [printBill],
  props: {
    onboards: {
      default: () => [],
    },
    branchName: "",
  },
  data() {
    return {
      output: null,
      printMode: false,
    };
  },

  computed: {
    group4() {
      return this.onboards[4] ? this.onboards[4] : [];
    },
    group5() {
      return this.onboards[5] ? this.onboards[5] : [];
    },
  },
  methods: {
    async print() {
      this.printMode = true;
      setTimeout(() => {
        this.printBill(this.$refs.chart, false, this.getallcss());
        this.printMode = false;
      }, 3000);
    },
  },
};
</script>
<style>
.avoid-page-break {
  page-break-inside: avoid !important;
}
</style>